import React, { useEffect } from 'react';
import api from '../../../../api';
import { convertUSDateToEUWithTime } from '../../../../util/DateHelper';

interface RelatedOffersProps {
    regNumber?: string;
}

const RelatedOffers: React.FC<RelatedOffersProps> = ({ regNumber }) => {

    const [relatedOffer, setRelatedOffer] = React.useState<Order | undefined>(undefined);
    useEffect(() => {
        if (regNumber)
        {
            const getOffer = async ()  => {
                const order = await api.OrderAPI.getOfferOrder(regNumber);
                 console.log("Related Offer:", order);
                setRelatedOffer(order);
               
            };
            getOffer();
        }
      
      
    }, []);
    if(relatedOffer)    
    {
        return (
            <div>
                Tilbud: <a href={`/worksheet/${relatedOffer.additionalData.orderId}`} target="_blank" rel="noopener noreferrer">{relatedOffer.additionalData.orderNr}</a> Oprettet: {convertUSDateToEUWithTime(relatedOffer.additionalData.createdDateTime)}
            </div>
        );
    }
    return null;
  
};

export default RelatedOffers;